<template>
  <div class="profile-menu">
    <div class="dropdown">
      <button class="dropbtn">
        <font-awesome-icon class="user-icon" icon="user"/>
      </button>
      <div class="dropdown-content">
        <a>ID: {{ user.username }}</a>
        <a>Volgers: {{ user.followersAmount }}</a>
        <a>Volgend: {{ user.followingAmount }}</a>
        <a>Berichten: {{ user.sharedPostsAmount }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileMenu",
  props: {
    user: Object,
  },
};
</script>
